import { render, staticRenderFns } from "./JourneySteps.vue?vue&type=template&id=21ce2bdd&scoped=true&"
import script from "./JourneySteps.vue?vue&type=script&lang=js&"
export * from "./JourneySteps.vue?vue&type=script&lang=js&"
import style0 from "./JourneySteps.vue?vue&type=style&index=0&id=21ce2bdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ce2bdd",
  null
  
)

export default component.exports